module.exports = __webpack_public_path__ + "img/vertical_1_1_0.62ba9645.png";